import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/authService";

function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ✅ NEW: Check token on load
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/import"); // redirect if already logged in
    }
  }, [navigate]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = await loginUser(form.email, form.password);

      // ✅ Save token
      localStorage.setItem("token", data.accessToken);

      // ✅ Redirect after login
      navigate("/import");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        
        <img src={'/logo.png'} alt="Logo" style={styles.logo} />

        <h2 style={styles.title}>Login</h2>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Enter email"
              value={form.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <label>Password</label>
            <input
              type="password"
              name="password"
              placeholder="Enter password"
              value={form.password}
              onChange={handleChange}
              required
              style={styles.input}
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f6f9",
  },
  card: {
    width: "360px",
    padding: "30px",
    borderRadius: "12px",
    background: "#2c2c2c",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    textAlign: "center",
    color: "#fff",
  },
  logo: {
    width: "auto",
    marginBottom: "15px",
  },
  title: {
    marginBottom: "20px",
    color: "#fff",
  },
  inputGroup: {
    textAlign: "left",
    marginBottom: "15px",
  },
  label: {
    fontSize: "14px",
    color: "#ccc",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    borderRadius: "6px",
    border: "1px solid #555",
    background: "#444",
    color: "#fff",
    outline: "none",
  },
  button: {
    width: "100%",
    padding: "10px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    marginTop: "10px",
    fontWeight: "bold",
  },
  error: {
    color: "#ff6b6b",
    marginBottom: "10px",
    fontSize: "14px",
  },
};